/* unplugin-vue-components disabled */import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import formatAmount from '@/shared/formatAmount';
import TrackingData from '@/shared/reportDataTracking';
import { useUserStore } from '@/stores/modules/user';
export default {
    __name: 'pay-all-popup',
    props: {
        value: Boolean,
        repayObj: Object
    },
    emits: [
        'close',
        'repay-all'
    ],
    setup: function(__props, param) {
        var emit = param.emit;
        var props = __props;
        var userStore = useUserStore();
        var enterTime = ref(new Date());
        watch(function() {
            return props.value;
        }, function(val) {
            if (val) {
                TrackingData.trackPopup(_object_spread_props(_object_spread({}, userStore.commonData), {
                    popKindName: 'popup_full_settlement',
                    taskHandler: 'popup-show'
                }));
            } else {
                TrackingData.trackClick(_object_spread_props(_object_spread({}, userStore.commonData), {
                    popKindName: 'popup_full_settlement',
                    taskHandler: 'popup-quit',
                    eventIntervalSpan: new Date() - enterTime.value
                }));
            }
        });
        var onOpenedPopup = function() {
            console.log('open');
        };
        var onClosedPopup = function() {
            console.log('close');
        };
        var goRepay = function(val) {
            emit('repay-all', val);
        };
        var trackClick = function() {
            TrackingData.trackClick(_object_spread_props(_object_spread({}, userStore.commonData), {
                popKindName: 'popup_full_settlement',
                taskHandler: 'popup-continue',
                eventIntervalSpan: new Date() - enterTime.value
            }));
        };
        return {
            __sfc: true,
            userStore: userStore,
            props: props,
            enterTime: enterTime,
            emit: emit,
            onOpenedPopup: onOpenedPopup,
            onClosedPopup: onClosedPopup,
            goRepay: goRepay,
            trackClick: trackClick,
            formatAmount: formatAmount
        };
    }
};
